module.exports = __webpack_public_path__ + "static/media/parakeet-details.cea31b90.jpg";